<script setup lang="ts">
import { computed, type Component } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { HomeIcon, GameIcon, DrawIcon, LeaderboardIcon, ProfileIcon } from '@/components/icons';

const route = useRoute();
const router = useRouter();

interface NavItem {
  label: string;
  icon: Component;
  to: string;
  routeName: string;
}

const items: NavItem[] = [
  { label: 'Home', icon: HomeIcon, to: '/', routeName: 'home' },
  { label: 'Schedule', icon: GameIcon, to: '/fixtures', routeName: 'fixtures' },
  { label: 'Raffles', icon: DrawIcon, to: '/draw', routeName: 'draw' },
  { label: 'Leagues', icon: LeaderboardIcon, to: '/leaderboard', routeName: 'leaderboard' },
  { label: 'Profile', icon: ProfileIcon, to: '/profile', routeName: 'profile' },
];

const activeRoute = computed(() => route.name as string);

function navigate(item: NavItem): void {
  router.push(item.to);
}
</script>

<template>
  <nav
    class="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-[480px] z-50"
    style="
      background: rgba(15, 15, 20, 0.92);
      backdrop-filter: blur(20px);
      -webkit-backdrop-filter: blur(20px);
      border-top: 1px solid rgba(255, 255, 255, 0.05);
    "
  >
    <div class="flex items-center justify-around py-2 px-1">
      <button
        v-for="item in items"
        :key="item.routeName"
        type="button"
        class="flex flex-col items-center gap-0.5 py-1.5 px-3 rounded-xl transition-all duration-200"
        @click="navigate(item)"
      >
        <component
          :is="item.icon"
          :size="26"
          :color="activeRoute === item.routeName ? '#FF1500' : '#55556A'"
        />
        <span
          class="text-[12px] font-semibold tracking-wide"
          :style="{
            color: activeRoute === item.routeName ? '#FF1500' : '#55556A',
            fontFamily: 'Barlow Condensed, Arial Narrow, arial, sans-serif',
          }"
        >
          {{ item.label }}
        </span>
        <!-- Active indicator dot -->
        <div
          v-if="activeRoute === item.routeName"
          class="w-1 h-1 rounded-full mt-0.5"
          style="background-color: #CC0000;"
        />
      </button>
    </div>
    <!-- Safe area spacer for notched devices -->
    <div class="h-[env(safe-area-inset-bottom)]" />
  </nav>
</template>
